import React, { FC } from 'react'
import './Nok.scss'

interface dataTypes {
    register: any
    errors: any
    handleChange: (value: any) => void
    values: any
}

const Nok: FC<dataTypes> = ({ register, errors, handleChange, values }) => {
  const dashroute = localStorage.getItem('__userRole')
  const isOfficer = dashroute === 'pscreen_officer'
  return (
        <div className="nok-modern">
            <div className="form-card">
                <div className="form-card-header">
                    <div className="header-icon">
                        <i className="fa fa-users"></i>
                    </div>
                    <h3 className="header-title">Next of Kin</h3>
                </div>
                <div className="form-card-body">

                    {
                        isOfficer
                          ? <div className="container-fluid">
                                <div className="row justify-content-between">
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Full Name <span className="text-danger">*</span></label>
                                        <input type={'text'} className='form-control' readOnly {...register('nextOfKinName', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinName && <span className="text-danger">{errors.nextOfKinName.message}</span>}
                                    </div>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Phone <span className="text-danger">*</span></label>
                                        <input type={'text'} className='form-control' readOnly {...register('nextOfKinPhone', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinPhone && <span className='text-danger'>{errors.nextOfKinPhone.message}</span>}
                                    </div>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Email <span className="text-danger">*</span></label>
                                        <input type={'email'} className='form-control' readOnly {...register('nextOfKinEmail', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinEmail && <span className='text-danger'>{errors.nextOfKinEmail.message}</span>}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Next Of Kin Gender <span className="text-danger">*</span></label>
                                        <input type={'text'} className='form-control' style={{ height: '45px' }} readOnly {...register('nextOfKinGender', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinGender && <span className='text-danger'>{errors.nextOfKinGender.message}</span>}
                                    </div>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Relationship <span className="text-danger">*</span></label>
                                        <input type={'text'} className='form-control' style={{ height: '45px' }} readOnly {...register('nextOfKinRelationship', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinRelationship && <span className='text-danger'>{errors.nextOfKinRelationship.message}</span>}
                                    </div>
                                </div>
                            </div>
                          : <div className="container-fluid">
                                <div className="row justify-content-between">
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Full Name <span className="text-danger">*</span></label>
                                        <input type={'text'} className='form-control' {...register('nextOfKinName', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinName && <span className="text-danger">{errors.nextOfKinName.message}</span>}
                                    </div>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Phone <span className="text-danger">*</span></label>
                                        <input type={'text'} className='form-control' {...register('nextOfKinPhone', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinPhone && <span className='text-danger'>{errors.nextOfKinPhone.message}</span>}
                                    </div>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Email <span className="text-danger">*</span></label>
                                        <input type={'email'} className='form-control' {...register('nextOfKinEmail', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinEmail && <span className='text-danger'>{errors.nextOfKinEmail.message}</span>}
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Next Of Kin Gender <span className="text-danger">*</span></label>

                                        <select id="" className="form-control" style={{ height: '45px' }} {...register('nextOfKinGender', { required: 'Please Insert Next Of King Gender' })} onChange={handleChange} >
                                            {values.nextOfKinGender === 'male' ? <option>Male</option> : <option>Female</option>}
                                            <option value="male">Male</option>
                                            <option value="female">Female</option>
                                        </select>

                                        {errors.nextOfKinGender && <span className='text-danger'>{errors.nextOfKinGender.message}</span>}
                                    </div>
                                    <div className='col-lg-4 col-md-12 col-sm-12'>
                                        <label>Relationship <span className="text-danger">*</span></label>
                                        <input type={'text'} className='form-control' {...register('nextOfKinRelationship', { required: 'Please fill the field' })} onChange={handleChange} />
                                        {errors.nextOfKinRelationship && <span className='text-danger'>{errors.nextOfKinRelationship.message}</span>}
                                    </div>
                                </div>
                            </div>
                    }

                </div>
            </div>
        </div>
  )
}

export default Nok
